<template>
    <div>
        <div id="preview" class="exam-wrapper">
            <div class="report_wrap">
                <div class="top">
                    <div class="top_left">
                        <img src="../../assets/qybg/1.png" alt="" class="logo_bg">
                        <img src="../../assets/qybg/logo.png" alt="" class="logo">
                    </div>
                    <div class="top_right">
                        <div class="top_title">{{ detail.page1.deptName }}</div>
                        <div class="top_tips">{{ detail.reportTimeFormat1 }}学习报告</div>
                        <div class="top_time" v-if="detail.page1.contractTime">协议有效期
                            <span>{{ detail.page1.contractTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_title">
                        <div>{{ detail.reportTimeFormat2 }}学习总览</div>
                    </div>
                    <div class="content_wrap">
                        <div class="content_left">
                            <div v-if="detail.page2.studyStatus == 0">
                                <p>感恩遇见，携手同行<br>非常感谢加入 中税网汇学堂 开启线上学习之旅！</p>
                                <p>每一堂课、每一次交流，都是成长路上的宝贵财富。未来的日子里，期待与您一起学习、进步，共同迈向财税领域的更高峰！</p>
                                <p>感恩相遇，愿我们携手并进，成就更好的自己！</p>
                            </div>
                            <div v-else-if="detail.page2.studyStatus == 1">
                                <p>振奋人心的消息来啦！</p>
                                <p>{{ detail.reportTimeFormat1 }}，我们的学习人数较上月大幅提升了{{ detail.page2.addOrDrugStudyRate }}%！
                                    这离不开每一位坚持学习的伙伴辛勤努力和付出，为你们点赞！
                                </p>
                                <p>这份成绩单，是大家共同进步的见证，也预示着更美好的未来！</p>
                            </div>
                            <div v-else-if="detail.page2.studyStatus == 2">
                                <p>暖心提示：</p>
                                <p>{{ detail.reportTimeFormat1 }}学习率较上月下滑了{{ detail.page2.addOrDrugStudyRate }}%！
                                    感谢坚持的学员！落后伙伴请速补进度，蓄力期更是逆袭时！
                                </p>
                                <p>别掉队，即刻登录追课程！</p>
                            </div>
                            <div v-else-if="detail.page2.studyStatus == 3">
                                <p>吹响汇学堂奋进号！</p>
                                <p>{{ detail.reportTimeFormat1 }}，学习率与上月持平，稳守更要突破！逆水行舟，全员加速！
                                </p>
                                <p>今日登录多学1小时，明日榜单见真章！</p>
                            </div>
                        </div>
                        <div class="content_right">
                            <div class="right_top">
                                <div class="right_top_item item1">
                                    <div class="right_top_point">{{ detail.page2.loginRate }}%</div>
                                    <div class="right_top_name">登录率</div>
                                </div>
                                <div class="right_top_item item2">
                                    <div class="right_top_point">{{ detail.page2.studyRate }}%</div>
                                    <div class="right_top_name">学习率</div>
                                </div>
                                <div class="right_top_item item3">
                                    <div class="right_top_point">{{ detail.page2.studyTime }}</div>
                                    <div class="right_top_name">学习时长</div>
                                    <div class="right_top_unit">(分钟)</div>
                                </div>
                            </div>
                            <div class="right_bottom">
                                <img src="../../assets/qybg/bg3.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_title">
                        <div>{{ detail.reportTimeFormat2 }}登录情况</div>
                    </div>
                    <div class="content_bottom_wrap">
                        <div class="content_left">
                            <img src="../../assets/qybg/icon3.png" alt="">
                            <div class="rate">{{ detail.page3.loginRate }}%</div>
                            <div class="name">登录率</div>
                            <div class="tips">阶段目标</div>
                        </div>
                        <div class="content_center">
                            <img src="../../assets/qybg/icon4.png" alt="">
                        </div>
                        <div class="content_right">
                            <div class="content_right_left">
                                <div style="margin-top: 60px;margin-left: 40px;">总账号数量：<span>{{ detail.page3.accountCount }}</span>个</div>
                                <div style="margin-top: 10px;margin-left: 40px;margin-bottom: 30px;">登录账号：<span>{{ detail.page3.loginUserCount }}</span>个</div>
                                <div style="font-size: 16px;margin-left: 40px;margin-bottom: 5px;">登录率=</div>
                                <div style="font-size: 16px;margin-left: 40px;">登录账号/总账号数量</div>
                            </div>
                            <div class="content_right_right">
                                <div style="padding: 0 10px;margin-bottom: 30px;margin-top: 30px;">{{ detail.reportTimeFormat1 }},
                                    <span v-if="detail.page3.studyStatus == 0">欢迎大家来到中税网汇学堂</span>
                                    <span v-if="detail.page3.studyStatus == 1">学员登录率飙升<span class="rateSize">{{ detail.page3.addOrDrugLoginRate }}%</span></span>
                                    <span v-else-if="detail.page3.studyStatus == 2">学员登录率下滑<span class="rateSize">{{ detail.page3.addOrDrugLoginRate }}%</span></span>
                                    <span v-else-if="detail.page3.studyStatus == 3">登录率与上月持平。</span>
                                </div>

                                <div style="padding-left: 10px;margin-bottom: 30px;" v-if="detail.page3.studyStatus == 0"><a href="https://drive.weixin.qq.com/s?k=AJYAowdoAAwZ31VPml" target="_blank">操作指南请查阅</a></div>
                                <div style="padding-left: 10px;margin-bottom: 30px;" v-else-if="detail.page3.studyStatus == 1">感谢迈出第一步的你！</div>
                                <div style="padding-left: 10px;margin-bottom: 30px;" v-else-if="detail.page3.studyStatus == 2">虽然这段时间学习人数不多，但短暂的休息是为了更好地蓄力前行。</div>
                                <div style="padding-left: 10px;margin-bottom: 30px;" v-else-if="detail.page3.studyStatus == 3">期待与大家一起迎接更多成长与突破！</div>

                                <div style="padding: 0 10px;" v-else-if="detail.page3.studyStatus == 1">汇学堂，与你一起，遇见更好的自己！</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_title">
                        <div>{{ detail.reportTimeFormat2 }}学习情况</div>
                    </div>
                    <div class="content_bottom_wrap">
                        <div class="content_left">
                            <img src="../../assets/qybg/icon3.png" alt="">
                            <div class="rate">{{ detail.page4.studyRate }}%</div>
                            <div class="name">学习率</div>
                            <div class="tips">阶段目标</div>
                        </div>
                        <div class="content_center">
                            <img src="../../assets/qybg/icon4.png" alt="">
                        </div>
                        <div class="content_right">
                            <div class="content_right_left">
                                <div style="margin-top: 60px;margin-left: 40px;">总账号数量：<span>{{ detail.page4.accountCount }}</span>个</div>
                                <div style="margin-top: 10px;margin-left: 40px;margin-bottom: 30px;">学习账号：<span>{{ detail.page4.studyCount }}</span>个</div>
                                <div style="font-size: 16px;margin-left: 40px;margin-bottom: 5px;">学习率=</div>
                                <div style="font-size: 16px;margin-left: 40px;">学习账号/总账号数量</div>
                            </div>
                            <div class="content_right_right">
                                <div style="padding: 0 10px;margin-bottom: 20px;margin-top: 30px;">学习课程：<span class="rateSize">{{ detail.page4.studyCourseCount }}</span>门</div>
                                <div style="padding: 0 10px;margin-bottom: 20px;">新报名学习：<span class="rateSize">{{ detail.page4.addStudyCourseCount }}</span>门</div>
                                <div style="padding: 0 10px;" v-if="detail.page4.categoryNameList.length > 0">主要集中在&nbsp;
                                    <span style="font-size: 20px;" v-for="(item, index) in detail.page4.categoryNameList" :key="index" class="rateSize">
                                        <span v-if="index+1 < detail.page4.categoryNameList.length">{{ item }}、</span>
                                        <span v-else>{{ item }}</span>
                                    </span>等内容
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content pageNext">
                    <div class="content_title1">
                        <div>{{ detail.reportTimeFormat2 }}课程学习排行</div>
                    </div>
                    <div class="content_table" v-if="detail.page5.studyCourseList.length > 0">
                        <div class="table_title">
                            <div class="table_title_sort">排行</div>
                            <div class="table_title_name">课程名称</div>
                            <div class="table_title_count">学习人数</div>
                            <div class="table_title_time">时长</div>
                        </div>
                        <div class="table_item" v-for="(item, index) in detail.page5.studyCourseList" :key="index">
                            <div class="table_title_sort">
                                <span v-if="index == 0" class="sort_index_1">{{ index+1 }}</span>
                                <span v-else-if="index == 1" class="sort_index_2">{{ index+1 }}</span>
                                <span v-else-if="index == 2" class="sort_index_3">{{ index+1 }}</span>
                                <span v-else>{{ index+1 }}</span>
                            </div>
                            <div class="table_title_name">{{ item.courseName }}</div>
                            <div class="table_title_count">{{ item.studyUserCount }}</div>
                            <div class="table_title_time">
                                <span v-if="item.studyTotalTime < 60">{{ item.studyTotalTime }}分钟</span>
                                <span v-else>{{ (item.studyTotalTime/60).toFixed(1) }}小时</span>
                            </div>
                        </div>
                    </div>
                    <div class="content_table" v-else>
                        <div class="nothing">
                            <img src="../../assets/img/zwsj.png" alt="">
                            <p>暂无数据</p>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_title1">
                        <div>{{ detail.reportTimeFormat2 }}学习时长情况</div>
                    </div>
                    <div class="content_study">
                        <div class="content_study_item content_study_item1">
                            <div>{{ detail.reportTimeFormat2 }}学习总体时长：
                                <span>{{ detail.page6.studyTotalTime }}</span>分钟
                            </div>
                            <div style="line-height: 30px;">{{ detail.reportTimeFormat2 }}学习冠军：<span style="color: #04ACBE;" v-if="detail.page6.studyTopMember">{{ detail.page6.studyTopMember.userName }}</span></div>
                            <div style="margin-top: 14px;">{{ detail.reportTimeFormat2 }}学习时长：
                                <span v-if="detail.page6.studyTopMember">{{ detail.page6.studyTopMember.studyTotalTime }}</span>
                                <span v-else>0</span>分钟
                            </div>
                        </div>
                        <div class="content_study_item content_study_item2">
                            <div>本月平均学习时长<span>{{ detail.page6.avgStudyTime }}</span>小时</div>
                            <div v-if="detail.page6.studyStatus == 0">希望领头羊的作用可以带动更多的学员参与进来，不要掉队太多呦！</div>
                            <div v-if="detail.page6.studyStatus == 1">稳步提升<span>{{ detail.page6.addOrDrugAvgTime }}</span>小时</div>
                            <div v-if="detail.page6.studyStatus == 2">有所下降<span>{{ detail.page6.addOrDrugAvgTime }}</span>小时</div>
                            <div v-if="detail.page6.studyStatus == 3">稳中有忧</div>
                            <div v-if="detail.page6.studyStatus == 1" style="font-size: 18px;">期待继续保持势头，携手共创新高！</div>
                            <div v-if="detail.page6.studyStatus == 2" style="font-size: 18px;">不要懈怠，厚积薄发正当时！</div>
                            <div v-if="detail.page6.studyStatus == 3" style="font-size: 18px;">持续突破方能领先，用行动刷新学习新高度！</div>
                        </div>
                    </div>
                </div>
                <div class="content pageNext">
                    <div class="content_title1">
                        <div>{{ detail.reportTimeFormat2 }}学习时长排行</div>
                    </div>
                    <div class="content_table1" v-if="studyMemberList.length > 0">
                        <div class="table_title">
                            <div class="table_title_sort">排行</div>
                            <div class="table_title_name">姓名</div>
                            <div class="table_title_time">学习时长</div>
                        </div>
                        <div class="table_item" v-for="(item, index) in studyMemberList" :key="index">
                            <div class="table_title_sort">
                                <span v-if="index == 0" class="sort_index_1">{{ index+1 }}</span>
                                <span v-else-if="index == 1" class="sort_index_2">{{ index+1 }}</span>
                                <span v-else-if="index == 2" class="sort_index_3">{{ index+1 }}</span>
                                <span v-else>{{ index+1 }}</span>
                            </div>
                            <div class="table_title_name">
                                <span v-if="item.userName">{{ item.userName }}</span>
                                <span v-else>用户_{{ item.userId }}</span>
                            </div>
                            <div class="table_title_time">
                                <span v-if="item.studyTotalTime < 60">{{ item.studyTotalTime }}分钟</span>
                                <span v-else>{{ (item.studyTotalTime/60).toFixed(1) }}小时</span>
                            </div>
                            <div class="table_title_point">
                                <div :style="{width: item.rate+'%'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="content_table1" v-else>
                        <div class="nothing">
                            <img src="../../assets/img/zwsj.png" alt="">
                            <p>暂无数据</p>
                        </div>
                    </div>
                </div>
                <div class="content" style="width: 100%;">
                    <div class="content_title1" style="width: calc(100% - 205px);margin: 0 auto;">
                        <div>{{ nextMonth }}月推荐好课</div>
                    </div>
                    <div class="content_foot">
                        <div class="footer_top">
                            <div class="footer_item">
                                <div class="footer_item_icon">
                                    <img style="width: 49px;height: 33px;" src="../../assets/qybg/icon5.png" alt="">
                                </div>
                                <div class="footer_item_name">会员录播课</div>
                                <div class="footer_class">
                                    <div v-for="(item, index) in detail.page7.recordList" :key="index" v-if="index < 5">
                                        {{ item.title }}
                                    </div>
                                </div>
                            </div>
                            <div class="footer_item">
                                <div class="footer_item_icon">
                                    <img style="width: 44px;height: 39px;" src="../../assets/qybg/icon6.png" alt="">
                                </div>
                                <div class="footer_item_name">会员直播课</div>
                                <img src="../../assets/qybg/ewm1.png" alt="">
                            </div>
                            <div class="footer_item">
                                <div class="footer_item_icon">
                                    <img style="width: 38px;height: 45px;" src="../../assets/qybg/icon7.png" alt="">
                                </div>
                                <div class="footer_item_name">全国线下课</div>
                                <img src="../../assets/qybg/ewm2.png" alt="">
                            </div>
                            <div class="footer_item">
                                <div class="footer_item_icon">
                                    <img style="width: 43px;height: 34px;" src="../../assets/qybg/icon8.png" alt="">
                                </div>
                                <div class="footer_item_name">更多内容资讯</div>
                                <div class="footer_class">
                                    <div>《财税道》、《答疑精选》请联系学习顾问......</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="footer_bottom">
                            <img src="../../assets/qybg/ewm1.png" alt="">
                            <img src="../../assets/qybg/ewm2.png" alt="">
                        </div>
                        <div class="footer_port">
                            <div>《财税道》、《答疑精选》请联系学习顾问......</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <el-button v-if="loading == false" size="small" style="position:fixed;right: 7%;top: 25px; z-index: 10000;" type="primary"
			@click="exportPDF">导出PDF</el-button>
    </div>
</template>

<script>
    import { PdfLoader } from "@/utils/pdfLoader";
    import { studyDetailReport } from '@/api/index.js'
    import { Loading } from 'element-ui';
    export default {
        name: 'exam',
        components: {},
        data() {
            return {
                detail: {},
                token: '',
                loading: false,
                studyMemberList: [],
                studyMonth: '',
                nextMonth: '',
            }
        },
        created() {
            this.token = window.localStorage.getItem('token')
            // this.token = 'Saas eyJhbGciOiJIUzUxMiJ9.eyJjbGllbnRUeXBlIjoiMyIsIm1vYmlsZSI6IjE1MjA3MTExMjU4IiwidXNlcklkIjoiMTYzNCIsInVzZXJLZXkiOiI5MGM3ZDIyYi1mM2Y1LTQxMzctOTc3MS05NjUzN2E2NTUwNTMifQ.ZJS9I2OiD5_W9jP-cmp8YCcWiZGgQlcSKaCivnz_ITiToW7OIzWD7OiF996mjznniQkf-UE5PwY3Iz9HrAVdEg'
            // localStorage.setItem('TopDeptId', 35)
            this.studyMonth = this.$route.params.year
            this.studyDetail()
        },
        methods: {
            studyDetail() {
                studyDetailReport({
                    studyMonth: this.studyMonth
                }, {
                    Authorization: this.token
                }).then((res) => {
                    if (res.code == 200) {
                        this.detail = res.data
                        let nowMonth = Number(res.data.reportTimeFormat2.replace('月', ''))
                        this.nextMonth = nowMonth == 12 ? 1 : nowMonth + 1
                        // 处理学习时长百分比
                        let studyMemberList = Object.assign([], res.data.page6.studyMemberList)
                        // studyMemberList = [
                        //     {
                        //         "userName": "TEST_李", //学习冠军账号
                        //         "userId": 5171,
                        //         "studyTotalTime": 5637
                        //     },
                        //     {
                        //         "userName": "会尽快收到回复尽快发货时间客户", //学习冠军账号
                        //         "userId": 5171,
                        //         "studyTotalTime": 900
                        //     },
                        //     {
                        //         "userName": "TEST_伊祎", //学习冠军账号
                        //         "userId": 5171,
                        //         "studyTotalTime": 50
                        //     },
                        // ]
                        if (studyMemberList.length > 0 && studyMemberList[0].studyTotalTime > 0) {
                            let longTime = studyMemberList[0].studyTotalTime
                            for (let  i = 0; i < studyMemberList.length; i++) {
                                studyMemberList[i].rate = (studyMemberList[i].studyTotalTime / longTime).toFixed(2) * 100
                            }
                            this.studyMemberList = studyMemberList
                        }
                    }
                })
            },
            exportPDF() {
                const loading = this.$loading({
                    lock: true,
                    text: "导出中",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                const element = document.querySelector("#preview");
                const pdfLoader = new PdfLoader(element, {
                    fileName: "企业统计报告",
                    direction: "p",
                    isPageMessage: false,
                    groupName: 'pageNext',
                    // baseX: 0,
                    // baseY: 0,
                });
                pdfLoader.getPdf().then((res) => {
                    loading.close();
                    this.$message.success("导出成功");
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .exam-wrapper {
        width: 1200px;
        margin: 0 auto;
    }
    .report_wrap {
        min-height: 100vh;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        .top {
            width: 100%;
            display: flex;
            margin-bottom: 50px;
            .top_left {
                width: 346px;
                height: 286px;
                position: relative;
                .logo_bg {
                    width: 100%;
                    height: 100%;
                }
                .logo {
                    position: absolute;
                    left: 61px;
                    width: 119px;
                    height: 63px;
                    top: 49px;
                }
            }
            .top_right {
                flex: 1;
                padding-left: 100px;
                .top_title {
                    font-weight: 800;
                    font-size: 44px;
                    color: #1ABABA;
                    margin-top: 70px;
                }
                .top_tips {
                    font-weight: 400;
                    font-size: 19px;
                    color: #171717;
                    margin: 30px 0 20px;
                }
                .top_time {
                    font-weight: 400;
                    font-size: 16px;
                    color: #C3C5CC;
                    span {
                        display: inline-block;
                        position: relative;
                        margin-left: 50px;
                        &::before {
                            content: '';
                            display: block;
                            position: absolute;
                            width: 16px;
                            height: 16px;
                            background-image: url(../../assets/qybg/icon1.png);
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-position: 0 0;
                            left: -22px;
                            top: 3px;
                        }
                    }
                }
            }
        }
        .pageNext {
            padding-top: 80px!important;
        }
        .content {
            width: calc(100% - 140px);
            margin: 0 auto;
            .content_title {
                position: relative;
                text-align: left;
                font-weight: 800;
                font-size: 31px;
                color: #161616;
                padding-left: 60px;
                margin-bottom: 60px;
                &::before {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 28px;
                    height: 28px;
                    left: 0;
                    top: 10px;
                    background: #FFBF53;
                    z-index: 2;
                    border-radius: 50%;
                }
                &::after {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 28px;
                    height: 28px;
                    left: 15px;
                    top: 10px;
                    background: #FFEAC8;
                    z-index: 1;
                    border-radius: 50%;
                }
                div {
                    position: relative;
                    display: inline-block;
                    &::after {
                        content: 'HUI XUE TANG';
                        position: absolute;
                        bottom: -30px;
                        left: 0px;
                        right: 0;
                        font-weight: bold;
                        font-size: 24px;
                        color: #FFF5E5;
                    }
                }
            }
            .content_wrap {
                display: flex;
                width: 100%;
                margin-bottom: 60px;
                .content_left {
                    width: 50%;
                    padding-right: 100px;
                    p {
                        line-height: 27px;
                        font-weight: 400;
                        font-size: 19px;
                        color: #171717;
                        text-align: justify;
                    }
                }
                .content_right {
                    width: 50%;
                    margin-top: -110px;
                    .right_top {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 50px;
                        .right_top_item {
                            width: 146px;
                            height: 219px;
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-position: 0 0;
                            text-align: center;
                            position: relative;
                            div {
                                width: 100%;
                            }
                            .right_top_point {
                                font-size: 27px;
                                color: #fff;
                                font-weight: 800;
                                position: absolute;
                                top: 73px;
                                left: 6px;
                            }
                            .right_top_name {
                                font-size: 15px;
                                color: #fff;
                                position: absolute;
                                top: 113px;
                                left: 7px;
                            }
                            .right_top_unit {
                                font-size: 12px;
                                color: #fff;
                                position: absolute;
                                top: 132px;
                                left: 7px;
                            }
                        }
                        .item1 {
                            background-image: url(../../assets/qybg/bg4.png);
                            .right_top_point, .right_top_name {
                                color: #161616 !important;
                            }
                        }
                        .item2 {
                            background-image: url(../../assets/qybg/bg5.png);
                        }
                        .item3 {
                            background-image: url(../../assets/qybg/bg6.png);
                        }
                    }
                    .right_bottom {
                        width: 509px;
                        height: 126px;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
            .content_bottom_wrap {
                display: flex;
                width: 100%;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 40px;
                .content_left {
                    position: relative;
                    width: 314px;
                    height: 225px;
                    margin-left: 25px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .rate {
                        position: absolute;
                        top: 65px;
                        left: 70px;
                        color: #fff;
                        font-size: 44px;
                        width: 90px;
                        text-align: center;
                    }
                    .name {
                        position: absolute;
                        top: 120px;
                        left: 80px;
                        color: #fff;
                        font-size: 22px;
                    }
                    .tips {
                        position: absolute;
                        right: 30px;
                        top: 80px;
                        font-weight: 800;
                        font-size: 24px;
                        color: #161616;
                        width: 50px;
                    }
                }
                .content_center {
                    margin-left: -70px;
                    img {
                        width: 18px;
                        height: 158px;
                    }
                }
                .content_right {
                    width: 500px;
                    height: 298px;
                    position: relative;
                    .content_right_left {
                        color: #191919;
                        font-size: 18px;
                        display: inline-block;
                        background-image: url(../../assets/qybg/bg1.png);
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        background-position: 0 0;
                        width: 266px;
                        height: 298px;
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        span {
                            font-size: 24px;
                            font-weight: 600;
                        }
                    }
                    .content_right_right {
                        color: #191919;
                        font-size: 16px;
                        display: inline-block;
                        background-image: url(../../assets/qybg/bg2.png);
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        background-position: 0 0;
                        width: 236px;
                        height: 271px;
                        position: absolute;
                        right: 14px;
                        top: 25px;
                        .rateSize {
                            color: #01B3C5;
                            font-size: 24px;
                            font-weight: 600;
                        }
                    }
                }
            }
            .content_title1 {
                position: relative;
                text-align: left;
                font-weight: 800;
                font-size: 31px;
                color: #161616;
                padding-left: 60px;
                margin-bottom: 60px !important;
                &::before {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 28px;
                    height: 28px;
                    left: 0;
                    top: 10px;
                    background: #02B3C5;
                    z-index: 2;
                    border-radius: 50%;
                }
                &::after {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    width: 28px;
                    height: 28px;
                    left: 15px;
                    top: 10px;
                    background: #A8E9EC;
                    z-index: 1;
                    border-radius: 50%;
                }
                div {
                    position: relative;
                    display: inline-block;
                    &::after {
                        content: 'HUI XUE TANG';
                        position: absolute;
                        bottom: -30px;
                        left: 0;
                        font-weight: bold;
                        font-size: 25px;
                        color: #BBEFEF;
                        width: 178px;
                    }
                }
            }
            .nothing {
                text-align: center;
                margin-top: 120px;
                img {
                    width: 300px;
                }
                p {
                    font-size: 24px;
                    color: #c6c4c4;
                    margin-top: 40px;
                }
            }
            .content_table {
                width: 100%;
                height: 980px;
                border: 1px solid #02B3C5;
                margin-top: 45px;
                margin-bottom: 70px;
                .table_title {
                    display: flex;
                    padding: 25px 30px 20px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #02B3C5;
                    .table_title_sort {
                        width: 50px;
                        text-align: center;
                    }
                    .table_title_name {
                        flex: 1;
                        text-align: left;
                    }
                    .table_title_count {
                        width: 70px;
                        text-align: center;
                    }
                    .table_title_time {
                        width: 100px;
                        text-align: center;
                    }
                }
                .table_item {
                    display: flex;
                    height: 44px;
                    line-height: 44px;
                    color: #fff;
                    font-size: 15px;
                    width: calc(100% - 60px);
                    margin: 0 auto;
                    &:nth-child(even) {
                        background: #02B3C5;
                    }
                    &:nth-child(odd) {
                        background: #03A1B1;
                    }
                    .table_title_sort {
                        width: 50px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .table_title_name {
                        flex: 1;
                        text-align: left;
                    }
                    .table_title_count {
                        width: 70px;
                        text-align: center;
                    }
                    .table_title_time {
                        width: 100px;
                        text-align: center;
                    }
                }
            }
            .content_study {
                display: flex;
                justify-content: space-around;
                margin-bottom: 45px;
                .content_study_item {
                    width: 50%;
                    width: 384px;
                    height: 194px;
                    border-radius: 30px;
                    font-size: 16px;
                    span {
                        font-weight: 600;
                        font-size: 36px;
                    }
                    div {
                        margin-left: 40px;
                        margin-top: 18px;
                        line-height: 24px;
                    }
                }
                .content_study_item1 {
                    background: linear-gradient( 227deg, #A7EFF9 0%, #F9FCFD 100%);
                    box-shadow: 2px 2 8px 2px rgba(0,0,0,0.09);
                    color: #191919;
                }
                .content_study_item2 {
                    background: #02B3C5;
                    box-shadow: 2px 2 8px 2px rgba(0,0,0,0.18);
                    color: #fff;
                }
            }
            .content_table1 {
                width: 100%;
                height: 980px;
                border: 1px solid #02B3C5;
                margin-top: 45px;
                margin-bottom: 70px;
                .table_title {
                    display: flex;
                    padding: 25px 30px 20px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #02B3C5;
                    .table_title_sort {
                        width: 50px;
                        text-align: center;
                    }
                    .table_title_name {
                        width: 100px;
                        text-align: left;
                        flex: 1;
                    }
                    .table_title_point {
                        flex: 1;
                        text-align: left;
                    }
                    .table_title_time {
                        width: 100px;
                        text-align: center;
                    }
                }
                .table_item {
                    display: flex;
                    height: 44px;
                    line-height: 44px;
                    color: #141414;
                    font-size: 15px;
                    width: calc(100% - 60px);
                    margin: 0 auto;
                    position: relative;
                    .table_title_sort {
                        width: 50px;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .sort_index_1, .sort_index_2, .sort_index_3 {
                            color: #fff;
                        }
                    }
                    .table_title_name {
                        text-align: left;
                        flex: 1;
                    }
                    .table_title_point {
                        position: absolute;
                        bottom: 0;
                        left: 50px;
                        right: 20px;
                        div {
                            background: #9DDDFA;
                            height: 5px;
                        }
                    }
                    .table_title_time {
                        width: 100px;
                        text-align: center;
                    }
                }
            }
            .content_foot {
                height: 460px;
                width: 100%;
                background-image: url(../../assets/qybg/bg7.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: 0 0;
                .footer_top {
                    display: flex;
                    justify-content: space-between;
                    width: 85%;
                    margin: 0 auto;
                    .footer_item {
                        margin-top: 50px;
                        width: 25%;
                        text-align: center;
                        .footer_item_icon {
                            width: 82px;
                            height: 82px;
                            border-radius: 41px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            margin: 0 auto;
                            &::after {
                                content: '';
                                position: absolute;
                                left: 0;
                                right: 0;
                                top: 0;
                                bottom: 0;
                                border: 1px solid #707070;
                                border-radius: 41px;
                                opacity: 0.15;
                                background: linear-gradient( 150deg, #838383 0%, #E6E6E6 100%);
                            }
                        }
                        .footer_item_name {
                            font-weight: bold;
                            font-size: 24px;
                            color: #141414;
                            margin-top: 30px;
                            margin-bottom: 20px;
                        }
                        img {
                            width: 95px;
                            height: 95px;
                        }
                        .footer_class {
                            font-weight: 400;
                            font-size: 14px;
                            color: #3C3C3C;
                            line-height: 18px;
                            text-align: left;
                            font-style: normal;
                            width: 270px;
                            height: 200px;
                            overflow: hidden;
                            div {
                                /* height: 36px; */
                                overflow: hidden;
                                margin-bottom: 5px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
            .sort_index_1 {
                width: 25px;
                height: 25px;
                display: block;
                background: #FFC250;
                border-radius: 25px;
                line-height: 27px;
                margin: 0 auto;
            }
            .sort_index_2 {
                width: 25px;
                height: 25px;
                display: block;
                background: #C2D2DE;
                border-radius: 25px;
                line-height: 27px;
                margin: 0 auto;
            }
            .sort_index_3 {
                width: 25px;
                height: 25px;
                display: block;
                background: #E3C09F;
                border-radius: 25px;
                line-height: 27px;
                margin: 0 auto;
            }
        }
    }
</style>
